// bill_subsystem_v1 + bill_channels_v1: manage Telegram + LINE channels
import React, { useState, useEffect } from 'react';
import API from '../api';

function fmtDate(s) {
  if (!s) return '-';
  try { return new Date(s).toLocaleDateString('th-TH', { day: '2-digit', month: 'short', year: 'numeric' }); } catch (e) { return s; }
}

export default function BillChannels() {
  const [telegrams, setTelegrams] = useState([]);
  const [lines, setLines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showTgModal, setShowTgModal] = useState(false);
  const [showLnModal, setShowLnModal] = useState(false);

  function reload() {
    setLoading(true);
    API.get('/api/bill/channels')
      .then(function (r) {
        setTelegrams(r.data.telegrams || []);
        setLines(r.data.lines || []);
      })
      .catch(function () {})
      .finally(function () { setLoading(false); });
  }

  useEffect(reload, []);

  /* bill_telegram_bot_v1: set บอทที่ใช้กับบิล */
  function setBillingBot(id) {
    API.patch('/api/bill/channels/telegram/' + id + '/set-billing').then(reload).catch(function (e) {
      alert('ตั้งไม่สำเร็จ: ' + ((e.response && e.response.data && e.response.data.error) || ''));
    });
  }

  function toggleChannel(type, id) {
    API.patch('/api/bill/channels/' + type + '/' + id + '/toggle').then(reload).catch(function () {});
  }

  function deleteChannel(type, id, name) {
    if (!window.confirm('ลบ ' + name + ' ?')) return;
    API.delete('/api/bill/channels/' + type + '/' + id).then(reload).catch(function (e) {
      alert('ลบไม่สำเร็จ: ' + ((e.response && e.response.data && e.response.data.error) || ''));
    });
  }

  return (
    <div style={{ padding: 20 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16, flexWrap: 'wrap', gap: 8 }}>
        <div>
          <h2 style={{ margin: 0 }}>📡 ช่องทาง</h2>
          <p style={{ margin: '4px 0 0', fontSize: 13, color: '#64748b' }}>จัดการ Telegram bot + LINE channel ของบริษัท</p>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <button onClick={function () { setShowTgModal(true); }} style={{ padding: '8px 14px', borderRadius: 8, border: 'none', background: '#0ea5e9', color: 'white', cursor: 'pointer', fontWeight: 600, fontSize: 14 }}>+ Telegram</button>
          <button onClick={function () { setShowLnModal(true); }} style={{ padding: '8px 14px', borderRadius: 8, border: 'none', background: '#10b981', color: 'white', cursor: 'pointer', fontWeight: 600, fontSize: 14 }}>+ LINE</button>
        </div>
      </div>

      {loading && <div style={{ color: '#94a3b8', fontSize: 13 }}>กำลังโหลด...</div>}

      {/* ===== TELEGRAM SECTION ===== */}
      <div style={{ marginBottom: 24 }}>
        <h3 style={{ fontSize: 15, color: '#0369a1', margin: '0 0 8px' }}>📱 Telegram Bots ({telegrams.length})</h3>
        {telegrams.length === 0 && !loading && (
          <div style={{ background: 'white', padding: 20, borderRadius: 10, textAlign: 'center', color: '#94a3b8', fontSize: 13 }}>ยังไม่มี Telegram bot</div>
        )}
        {telegrams.length > 0 && (
          <div style={{ background: 'white', borderRadius: 10, overflow: 'hidden', border: '1px solid #e2e8f0' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                  <th style={{ padding: 10, textAlign: 'left' }}>ชื่อ</th>
                  <th style={{ padding: 10, textAlign: 'left' }}>Bot Token</th>
                  <th style={{ padding: 10, textAlign: 'left' }}>Chat ID</th>
                  <th style={{ padding: 10, textAlign: 'center' }}>สถานะ</th>
                  <th style={{ padding: 10, textAlign: 'center' }}>ใช้กับบิล</th>{/* bill_telegram_bot_v1 */}
                  <th style={{ padding: 10, textAlign: 'center' }}>วันสร้าง</th>
                  <th style={{ padding: 10, textAlign: 'center' }}>การกระทำ</th>
                </tr>
              </thead>
              <tbody>
                {telegrams.map(function (t) {
                  return (
                    <tr key={t.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                      <td style={{ padding: 10, fontWeight: 600 }}>{t.name}</td>
                      <td style={{ padding: 10, fontFamily: 'monospace', fontSize: 11, color: '#64748b' }}>{t.bot_token_masked}</td>
                      <td style={{ padding: 10, fontFamily: 'monospace', fontSize: 12 }}>{t.chat_id}</td>
                      <td style={{ padding: 10, textAlign: 'center' }}>
                        <button onClick={function () { toggleChannel('telegram', t.id); }} style={{ padding: '4px 10px', borderRadius: 999, border: 'none', background: t.is_active ? '#dcfce7' : '#fee2e2', color: t.is_active ? '#15803d' : '#dc2626', cursor: 'pointer', fontSize: 11, fontWeight: 600 }}>{t.is_active ? '✓ เปิด' : '✕ ปิด'}</button>
                      </td>
                      <td style={{ padding: 10, textAlign: 'center' }}>{/* bill_telegram_bot_v1 */}
                        <button onClick={function () { if (!t.use_for_billing) { setBillingBot(t.id); } }} style={{ padding: '4px 10px', borderRadius: 999, border: 'none', background: t.use_for_billing ? '#10b981' : '#f1f5f9', color: t.use_for_billing ? '#fff' : '#475569', cursor: t.use_for_billing ? 'default' : 'pointer', fontSize: 11, fontWeight: 600 }}>{t.use_for_billing ? '✓ ใช้อยู่' : 'ตั้งใช้'}</button>
                      </td>
                      <td style={{ padding: 10, textAlign: 'center', fontSize: 11, color: '#94a3b8' }}>{fmtDate(t.created_at)}</td>
                      <td style={{ padding: 10, textAlign: 'center' }}>
                        <button onClick={function () { deleteChannel('telegram', t.id, t.name); }} style={{ padding: '4px 10px', borderRadius: 6, border: '1px solid #fecaca', background: 'white', color: '#dc2626', cursor: 'pointer', fontSize: 11 }}>ลบ</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* ===== LINE SECTION ===== */}
      <div>
        <h3 style={{ fontSize: 15, color: '#047857', margin: '0 0 8px' }}>💬 LINE Channels ({lines.length})</h3>
        {lines.length === 0 && !loading && (
          <div style={{ background: 'white', padding: 20, borderRadius: 10, textAlign: 'center', color: '#94a3b8', fontSize: 13 }}>ยังไม่มี LINE channel</div>
        )}
        {lines.length > 0 && (
          <div style={{ background: 'white', borderRadius: 10, overflow: 'hidden', border: '1px solid #e2e8f0' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13 }}>
              <thead>
                <tr style={{ background: '#f8fafc', borderBottom: '1px solid #e2e8f0' }}>
                  <th style={{ padding: 10, textAlign: 'left' }}>ชื่อ</th>
                  <th style={{ padding: 10, textAlign: 'left' }}>Access Token</th>
                  <th style={{ padding: 10, textAlign: 'center' }}>โควต้า</th>
                  <th style={{ padding: 10, textAlign: 'center' }}>สถานะ</th>
                  <th style={{ padding: 10, textAlign: 'center' }}>วันสร้าง</th>
                  <th style={{ padding: 10, textAlign: 'center' }}>การกระทำ</th>
                </tr>
              </thead>
              <tbody>
                {lines.map(function (c) {
                  return (
                    <tr key={c.id} style={{ borderBottom: '1px solid #f1f5f9' }}>
                      <td style={{ padding: 10, fontWeight: 600 }}>{c.name}</td>
                      <td style={{ padding: 10, fontFamily: 'monospace', fontSize: 11, color: '#64748b' }}>{c.channel_access_token_masked}</td>
                      <td style={{ padding: 10, textAlign: 'center', fontSize: 11 }}>{c.quota_status || '-'}</td>
                      <td style={{ padding: 10, textAlign: 'center' }}>
                        <button onClick={function () { toggleChannel('line', c.id); }} style={{ padding: '4px 10px', borderRadius: 999, border: 'none', background: c.is_active ? '#dcfce7' : '#fee2e2', color: c.is_active ? '#15803d' : '#dc2626', cursor: 'pointer', fontSize: 11, fontWeight: 600 }}>{c.is_active ? '✓ เปิด' : '✕ ปิด'}</button>
                      </td>
                      <td style={{ padding: 10, textAlign: 'center', fontSize: 11, color: '#94a3b8' }}>{fmtDate(c.created_at)}</td>
                      <td style={{ padding: 10, textAlign: 'center' }}>
                        <button onClick={function () { deleteChannel('line', c.id, c.name); }} style={{ padding: '4px 10px', borderRadius: 6, border: '1px solid #fecaca', background: 'white', color: '#dc2626', cursor: 'pointer', fontSize: 11 }}>ลบ</button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {showTgModal && <TelegramModal onClose={function (refresh) { setShowTgModal(false); if (refresh) reload(); }} />}
      {showLnModal && <LineModal onClose={function (refresh) { setShowLnModal(false); if (refresh) reload(); }} />}
    </div>
  );
}

// ============================================
// TELEGRAM ADD MODAL
// ============================================
function TelegramModal(props) {
  const [form, setForm] = useState({ name: '', bot_token: '', chat_id: '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  async function handleSave() {
    setError('');
    if (!form.name.trim() || !form.bot_token.trim() || !form.chat_id.trim()) {
      setError('กรอกครบทุกช่อง');
      return;
    }
    setSaving(true);
    try {
      await API.post('/api/bill/channels/telegram', form);
      props.onClose(true);
    } catch (e) {
      setError((e.response && e.response.data && e.response.data.error) || 'เพิ่มไม่สำเร็จ');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div onClick={function () { if (!saving) props.onClose(false); }} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, zIndex: 100 }}>
      <div onClick={function (e) { e.stopPropagation(); }} style={{ background: 'white', borderRadius: 14, padding: 24, maxWidth: 500, width: '100%' }}>
        <h3 style={{ margin: '0 0 12px' }}>📱 เพิ่ม Telegram Bot</h3>
        <p style={{ margin: '0 0 16px', fontSize: 12, color: '#64748b' }}>สร้าง bot ผ่าน @BotFather ใน Telegram → ได้ token + chat_id</p>

        <div style={{ marginBottom: 10 }}>
          <label style={{ fontSize: 13 }}>ชื่อ (สำหรับอ้างอิง)</label>
          <input value={form.name} onChange={function (e) { setForm(Object.assign({}, form, { name: e.target.value })); }} placeholder="เช่น Bot ขาย" style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 14, marginTop: 4, boxSizing: 'border-box' }} />
        </div>

        <div style={{ marginBottom: 10 }}>
          <label style={{ fontSize: 13 }}>Bot Token</label>
          <input value={form.bot_token} onChange={function (e) { setForm(Object.assign({}, form, { bot_token: e.target.value })); }} placeholder="123456:ABC-DEF..." style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 13, marginTop: 4, boxSizing: 'border-box', fontFamily: 'monospace' }} />
        </div>

        <div style={{ marginBottom: 16 }}>
          <label style={{ fontSize: 13 }}>Chat ID</label>
          <input value={form.chat_id} onChange={function (e) { setForm(Object.assign({}, form, { chat_id: e.target.value })); }} placeholder="ตัวเลข เช่น -1001234567890" style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 13, marginTop: 4, boxSizing: 'border-box', fontFamily: 'monospace' }} />
        </div>

        {error && <div style={{ background: '#fef2f2', color: '#dc2626', padding: 10, borderRadius: 8, fontSize: 13, marginBottom: 12 }}>⚠️ {error}</div>}

        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button onClick={function () { props.onClose(false); }} disabled={saving} style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid #e2e8f0', background: 'white', cursor: 'pointer', fontSize: 14 }}>ยกเลิก</button>
          <button onClick={handleSave} disabled={saving} style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: saving ? '#94a3b8' : '#0ea5e9', color: 'white', cursor: saving ? 'not-allowed' : 'pointer', fontSize: 14, fontWeight: 600 }}>{saving ? 'กำลังบันทึก...' : 'บันทึก'}</button>
        </div>
      </div>
    </div>
  );
}

// ============================================
// LINE ADD MODAL
// ============================================
function LineModal(props) {
  const [form, setForm] = useState({ name: '', channelAccessToken: '', channelSecret: '', webhookToken: '' });
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  async function handleSave() {
    setError('');
    if (!form.name.trim() || !form.channelAccessToken.trim() || !form.channelSecret.trim()) {
      setError('กรอกครบ ชื่อ / Access Token / Secret');
      return;
    }
    setSaving(true);
    try {
      await API.post('/api/bill/channels/line', form);
      props.onClose(true);
    } catch (e) {
      setError((e.response && e.response.data && e.response.data.error) || 'เพิ่มไม่สำเร็จ');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div onClick={function () { if (!saving) props.onClose(false); }} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, zIndex: 100 }}>
      <div onClick={function (e) { e.stopPropagation(); }} style={{ background: 'white', borderRadius: 14, padding: 24, maxWidth: 500, width: '100%' }}>
        <h3 style={{ margin: '0 0 12px' }}>💬 เพิ่ม LINE Channel</h3>
        <p style={{ margin: '0 0 16px', fontSize: 12, color: '#64748b' }}>สร้าง channel ใน LINE Developers Console → ได้ Access Token + Channel Secret</p>

        <div style={{ marginBottom: 10 }}>
          <label style={{ fontSize: 13 }}>ชื่อ (สำหรับอ้างอิง)</label>
          <input value={form.name} onChange={function (e) { setForm(Object.assign({}, form, { name: e.target.value })); }} placeholder="เช่น LINE ขาย" style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 14, marginTop: 4, boxSizing: 'border-box' }} />
        </div>

        <div style={{ marginBottom: 10 }}>
          <label style={{ fontSize: 13 }}>Channel Access Token</label>
          <textarea rows={2} value={form.channelAccessToken} onChange={function (e) { setForm(Object.assign({}, form, { channelAccessToken: e.target.value })); }} placeholder="ยาว ~170 ตัวอักษร" style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 12, marginTop: 4, boxSizing: 'border-box', fontFamily: 'monospace', resize: 'vertical' }} />
        </div>

        <div style={{ marginBottom: 10 }}>
          <label style={{ fontSize: 13 }}>Channel Secret</label>
          <input value={form.channelSecret} onChange={function (e) { setForm(Object.assign({}, form, { channelSecret: e.target.value })); }} placeholder="32 ตัวอักษร" style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 13, marginTop: 4, boxSizing: 'border-box', fontFamily: 'monospace' }} />
        </div>

        <div style={{ marginBottom: 16 }}>
          <label style={{ fontSize: 13 }}>Webhook Token (optional)</label>
          <input value={form.webhookToken} onChange={function (e) { setForm(Object.assign({}, form, { webhookToken: e.target.value })); }} placeholder="สำหรับ webhook verification" style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 13, marginTop: 4, boxSizing: 'border-box', fontFamily: 'monospace' }} />
        </div>

        {error && <div style={{ background: '#fef2f2', color: '#dc2626', padding: 10, borderRadius: 8, fontSize: 13, marginBottom: 12 }}>⚠️ {error}</div>}

        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button onClick={function () { props.onClose(false); }} disabled={saving} style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid #e2e8f0', background: 'white', cursor: 'pointer', fontSize: 14 }}>ยกเลิก</button>
          <button onClick={handleSave} disabled={saving} style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: saving ? '#94a3b8' : '#10b981', color: 'white', cursor: saving ? 'not-allowed' : 'pointer', fontSize: 14, fontWeight: 600 }}>{saving ? 'กำลังบันทึก...' : 'บันทึก'}</button>
        </div>
      </div>
    </div>
  );
}
